/* A FINISHED WORKOUT'S REVIEW STATE — the TWIN of `HybridTrainer/Services/CoachReviewState.swift` (the Swift is the rule;
 * `reviewStateCorpus.test.ts` holds this equal to it on every case the Swift emits). W82 §8 item 3. PURE.
 *   waiting — no `review` row names the session · unseen — one does, the client's `read_at` is null · seen — stamped.
 * The FIRST review row naming the session decides (a tie on the instant breaks on the id). `unseenCount` is the badge. */

export type ReviewState = "waiting" | "unseen" | "seen";
export type StateMark = { readonly id: string; readonly kind: string; readonly sessionId: string | null; readonly createdAtISO: string; readonly readAtISO: string | null };

export function reviewOf<M extends StateMark>(sessionId: string, marks: readonly M[]): M | null {
  let best: M | null = null;
  for (const m of marks) {
    if (m.kind !== "review" || m.sessionId !== sessionId) continue;
    if (best === null) { best = m; continue; }
    const a = Date.parse(m.createdAtISO), b = Date.parse(best.createdAtISO);
    if (a < b || (a === b && m.id.toLowerCase() < best.id.toLowerCase())) best = m;
  }
  return best;
}

export function reviewState(sessionId: string, marks: readonly StateMark[]): ReviewState {
  const r = reviewOf(sessionId, marks);
  return r === null ? "waiting" : r.readAtISO === null ? "unseen" : "seen";
}

export function unseenCount(marks: readonly StateMark[]): number {
  return marks.filter((m) => m.kind === "review" && m.readAtISO === null).length;
}

/** The web's words for the coach: `seen` / `not seen yet` beside a sent review. */
export function seenWords(state: ReviewState): string | null {
  return state === "seen" ? "seen" : state === "unseen" ? "not seen yet" : null;
}
